import Box from '@mui/material/Box';
import { useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@/theme/colors';
import ExpHubIcon from '@/assets/images/logo/eXp-hub-logo-icon.svg?react';
import MyeXpIcon from '@/assets/images/logo/trx-favicon.svg?react';
import BoldtrailIcon from '@/assets/images/logo/boldtrail-logo.svg?react';
import LoftyIcon from '@/assets/images/logo/lofty-logo.svg?react';
import ClozeIcon from '@/assets/images/logo/cloze-logo.svg?react';
import SkySlopeIcon from '@/assets/images/logo/skyslope-logo.svg?react';
import SisuIcon from '@/assets/images/logo/sisu-logo.svg?react';

interface AppButtonProps {
  title: string;
  url?: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const AppButton: React.FC<AppButtonProps> = ({ title, url, icon: Icon }) => {
  const theme = useTheme();

  const handleClick = () => {
    if (url) window.open(url, '_blank');
  };

  return (
    <Box
      onClick={handleClick}
      data-testid={`app-button-${title.toLowerCase().replace(/\s+/g, '-')}`}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        backgroundColor:
          theme.palette.mode === 'light' ? '#f3f4f6' : 'rgba(255,255,255,0.1)',
        padding: '0.5rem 1rem',
        borderRadius: '4px',
        fontSize: '0.875rem',
        color:
          theme.palette.mode === 'dark'
            ? colors.white
            : theme.palette.secondary.main,
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'color 0.2s ease',
        '&:hover': {
          // color:
          //   theme.palette.mode === 'dark' ? colors.blue400 : colors.royal80,
          backgroundColor:
            theme.palette.mode === 'light'
              ? '#e5e7eb'
              : 'rgba(255,255,255,0.15)',
        },
      }}
    >
      {Icon && (
        <Icon
          style={{
            width: '20px',
            height: '20px',
            flexShrink: 0,
          }}
        />
      )}
      {title}
    </Box>
  );
};

const ApplicationButtons = () => {
  const { t } = useTranslation(['resources']);

  return (
    <Box
      data-testid="application-buttons-container"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1,
        flexWrap: 'wrap',
        justifyContent: 'center',
      }}
    >
      <AppButton
        title={t('eXpHub')}
        url="https://hub.exprealty.com/connect"
        icon={ExpHubIcon}
      />
      <AppButton
        title={t('myeXp')}
        url="https://my.exprealty.com/"
        icon={MyeXpIcon}
      />

      <AppButton
        title={t('Boldtrail')}
        url="https://boldtrail.exprealty.com/"
        icon={BoldtrailIcon}
      />
      <AppButton title={t('Lofty')} url="https://lofty.com/" icon={LoftyIcon} />
      <AppButton
        title={t('Cloze')}
        url="https://exprealty.okta.com/app/cloze/exk1462xgd8b2nzSg2p8/sso/saml"
        icon={ClozeIcon}
      />
      <AppButton
        title={t('skySlope')}
        url="https://app.skyslope.com/"
        icon={SkySlopeIcon}
      />
      <AppButton title={t('sisu')} url="https://app.sisu.co/" icon={SisuIcon} />
    </Box>
  );
};

export default ApplicationButtons;
